import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const UserInformation = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Email'}
        field={'email'}
        type={'link'}
        target={'_blank'}
        href={`mailto:${data?.email}`}
      />
      <DescriptionItem label={'Company'} field={'company.name'} />
      <DescriptionItem label={'Studio'} field={'studio.name'} />
      <DescriptionItem label={'Department'} field={'department'} />
      <DescriptionItem label={'Team'} field={'team.name'} />
      <DescriptionItem label={'Super team'} field={'superTeam.name'} />
      <DescriptionItem label={'Manager'} field={'manager'} />
      <DescriptionItem label={'Position'} field={'position'} />
      <DescriptionItem
        label={'Profile'}
        field={'profile'}
        type={'link'}
        target={'_blank'}
        href={data?.profile}
      />
      <DescriptionItem
        label={'Type'}
        field={'isSystem'}
        valueParser={(isSystem) => (isSystem ? 'System user' : 'User')}
      />
      <DescriptionItem
        label={'Is test'}
        field={'isTest'}
        valueParser={(value) => (value ? 'Yes' : 'No')}
      />
    </DescriptionList>
  );
};

export default UserInformation;
